import React, { useEffect, useState } from 'react';
import { HEADER_WIDE_BOX_HANDICAP_TYPES, WIDE_BOX_HANDICAP_TYPES } from '../data/constants';
import { classIf, filterEntries, getTournamentUniqueId, isAsianHandicap } from '../data/utils';
import { getLabel } from '../data/labels';
import Odd from './Odd';

function filterBets(bets, filter) {
    if (filter.length === 0) {
        return bets;
    }
    return filterEntries(bets, filter, b => b.handicapDesc);
}

export function getFirstLine(bets) {
    let firstLine = bets[0];
    for (let i = 0; i < bets.length; i++) {
        const bet = bets[i];
        if (bet?.mainLine > 0 && bet.mainLine === bet.handicap) {
            firstLine = bet;
            break;
        }
    }
    return firstLine;
}

function byHandycapDesc(a, b) {
    return a.handicapDesc.localeCompare(b.handicapDesc);
}

function UOBox(props) {
    let [betDesc, setBetDesc] = useState(getFirstLine(props.bets).handicapDesc);
    const [filter, setFilter] = useState('');

    useEffect(() => {
        const tournamentId = getTournamentUniqueId(props.bets[0].uniqueId);
        const type = `hcp-selection-${tournamentId}-${props.bets[0].id}`;

        function listener(e) {
            setBetDesc(e.detail.handicapDesc);
        }
        window.addEventListener(type, listener);

        return () => {
            window.removeEventListener(type, listener);
        }
    }, []);

    // Imposta l'indice della scommessa associata all'handicap selezionato
    function handleClick(bet) {
        setBetDesc(bet.handicapDesc);
    }

    let showLocks = false;
    let bet = props.bets.find(bet => bet.handicapDesc === betDesc);
    if (bet == null) {
        bet = props.bets[0];
        showLocks = true;
    }
    if(!bet.hasOdds) {
        bet.h = 0;
        bet.handicap = 0;
        bet.handicapDesc = '';
    }
    const nOdds = bet.odds.length;
    let forceWideBox = WIDE_BOX_HANDICAP_TYPES.includes(bet.tipoHandicap);

    const handleAsianHandicap = isAsianHandicap(bet.id);

    if (handleAsianHandicap) {
        betDesc = betDesc.startsWith('-') ? betDesc.replace('-', '-+') : '+-' + betDesc;
    }

    const bets = filterBets(props.bets, filter).sort(byHandycapDesc);
    const renderedLines = [];
    bets.forEach(function(bet, i) {
        let hcpDesc = bet.handicapDesc;
        if (handleAsianHandicap) {
            hcpDesc = hcpDesc.startsWith('-') ? hcpDesc.replace('-', '-+') : '+-' + hcpDesc;
        }
        renderedLines.push(
            <React.Fragment key={bet.uniqueId}>
                <a className={"dropdown-item text-center" + classIf(bet.handicapDesc === betDesc, 'selezionata')} onClick={handleClick.bind(this, bet)}>{hcpDesc}</a>
                {bet.odds.map(odd =>
                    <Odd key={odd.uniqueId} {...odd} />
                )}
            </React.Fragment>
        );
    });
    return (
        <div key={betDesc} className="gridInterernaQuotazioni">
            {props.bets.length > 1 ? 
                <>
                    <button className={"dropdown-toggle text-uppercase bg-transparent bordo-tondo mx-1 " + (forceWideBox === true ? "bottone-quota-largo" : '')} type="button" data-toggle="dropdown">
                        <span className="uo-selezionato tinytext">{betDesc}</span>
                    </button>
                    <div id="uo-box-dropdown" className="dropdown-menu">
                        <div className="ricerca-fastbet-in-quote">
                            <input className="input-personalizzato-fastbet-ricerca" type="text" placeholder={getLabel('general.ricerca')} value={filter} onChange={(e) => setFilter(e.target.value)} autoFocus autoComplete="off" />
                        </div>
                        <div id="uo-box-dropdown-header" className={`lista-quote colonne-${nOdds + 1} grassetto`}>
                            <span className="text-uppercase grassetto">{bet.handicapTableDesc}</span>
                            {bet.odds.map(odd => {
                                let oddDesc = odd.descNoHandicap || odd.desc;
                                if (HEADER_WIDE_BOX_HANDICAP_TYPES.includes(bet.tipoHandicap)) {
                                    oddDesc = bet.eqs.find(e => e.ce === odd.id).d;
                                }

                                return (
                                    <span key={odd.uniqueId}>{oddDesc}</span>
                                );
                            })}
                        </div>
                        <div className="dropdown-content">
                            <div className={`lista-quote colonne-${nOdds + 1}`}>
                                {renderedLines}
                            </div>
                        </div>
                    </div>
                </>
                :
                <button className={"dropdown-toggle dropdown-toggle-no-arrow text-uppercase bg-transparent bordo-tondo mx-1 " + (forceWideBox === true ? "bottone-quota-largo" : '')}>
                    <span className="uo-selezionato tinytext">
                        {function() {
                            let hcpDesc = bet.handicapDesc;
                            if (handleAsianHandicap) {
                                hcpDesc = hcpDesc.startsWith('-') ? hcpDesc.replace('-', '-+') : '+-' + hcpDesc;
                            }
                            return (bet.handicapDesc !== '' && bet.handicapDesc !== '0') ? hcpDesc : <i className="fa fa-lock"></i>
                        }()}
                    </span>
                </button>
            }
            {bet.odds.map(odd => {
                return (
                    <React.Fragment key={odd.id}>
                         {showLocks ?
                            <div className="contenitoreSingolaQuota bordo-tondo mx-1">
                                <p className="titoloQuotazione text-uppercase grigio mb-1">
                                    {odd.desc}
                                </p>
                                <p className="tipoQuotazione_1"><i className="fa fa-lock"></i></p>
                            </div>
                         	:
                            <Odd {...odd} />
                         }
                    </React.Fragment>
                )
            })}
        </div>
    );
}

export default UOBox;